<button mat-icon-button type="button" (click)="toggleSidenav()">
  <span class="relative flex items-center">
    <mat-icon>menu</mat-icon>
  </span>
</button>
